<div class="row document overflow-hidden">
  <div class="col-12 document overflow-hidden">
    <div class="d-flex justify-content-between">
      <p class="warning"><span *ngIf="showWarning">{{"messages.warning_data_lot" | translate}}</span></p>
      <a class="view-docx" (click)="preview($event)">{{ "button.view_docx" | translate }}</a>
    </div>
    <app-form-template-moha class="form-handsontable" #formTemplate></app-form-template-moha>
  </div>
</div>